"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LIFE_CYCLE = exports.LIFE_CYCLE_TASK = exports.PG_BQ_TIMEZONE_MAPPING = exports.getNormalizedWorkspaceSegment = exports.getNormalizedWorkspaceType = exports.WORKSPACE_TEMPLATE_TO_SEGMENT = exports.THOUSAND_SEPARATOR = exports.WORKSPACE_SEGMENT = exports.DEFAULT_CLIENT_TEMPLATES = exports.WORKSPACE_TYPE = exports.ACTION_INCLUDE_TYPE = exports.NUMBER_FILTER = exports.DEFAULT_DATE_FILTER = exports.LANGUAGE = exports.WEB_LOGIN_MODE = exports.MOBILE_LOGIN_MODE = exports.INVOICED_BY = exports.CLIENT_CATEGORY = exports.MOBILE_LOCK_SCREEN_TIMEOUT = exports.CAPACITY_QUOTA_FOR_ENTERPRISE = exports.CAPACITY_QUOTA_FOR_LIVE = exports.CAPACITY_QUOTA_FOR_TRIAL = exports.CLIENT_SECTORS = exports.CLIENT_REGIONS = exports.TERRITORY_SCOPE = exports.PERSONA = exports.BILLING_TYPE = exports.PRO_PLAN_STATUSES = exports.FREE_TRIAL_DB_STATUSES = exports.MAIN_DB_STATUSES = exports.CLIENT_STATUS = void 0;
var CLIENT_STATUS;
(function (CLIENT_STATUS) {
    CLIENT_STATUS["PILOT"] = "pilot";
    CLIENT_STATUS["LIVE"] = "live";
    CLIENT_STATUS["STARTER"] = "starter";
    CLIENT_STATUS["TRIAL"] = "trial";
    CLIENT_STATUS["EXPIRED"] = "expired";
    /** @deprecated */
    CLIENT_STATUS["FREE_TRIAL"] = "free_trial";
})(CLIENT_STATUS || (exports.CLIENT_STATUS = CLIENT_STATUS = {}));
exports.MAIN_DB_STATUSES = [
    CLIENT_STATUS.PILOT,
    CLIENT_STATUS.LIVE,
];
exports.FREE_TRIAL_DB_STATUSES = [
    CLIENT_STATUS.STARTER,
    CLIENT_STATUS.TRIAL,
    CLIENT_STATUS.EXPIRED,
    /** @deprecated */
    CLIENT_STATUS.FREE_TRIAL, // LEGACY
];
/**
 * Client statuses that indicate the client's plan should be "Pro" in Stripe.
 * NB: we include TRIAL because apart from the cluster being different, the functionnalities should be the same as a LIVE client
 *
 * TRIAL -> automated billing
 * PILOT -> billing should not be automated, but we include it here just in case
 * LIVE  -> billing can be automated or custom, depending on how the client was onboarded
 */
exports.PRO_PLAN_STATUSES = [
    CLIENT_STATUS.TRIAL,
    CLIENT_STATUS.PILOT,
    CLIENT_STATUS.LIVE,
];
var BILLING_TYPE;
(function (BILLING_TYPE) {
    BILLING_TYPE["AUTOMATED"] = "automated";
    BILLING_TYPE["CUSTOM"] = "custom";
})(BILLING_TYPE || (exports.BILLING_TYPE = BILLING_TYPE = {}));
var PERSONA;
(function (PERSONA) {
    PERSONA["DRIVER"] = "DRIVER";
    PERSONA["SALES_REPRESENTATIVE"] = "SALES_REPRESENTATIVE";
    PERSONA["VAN_SALES"] = "VAN_SALES";
})(PERSONA || (exports.PERSONA = PERSONA = {}));
var TERRITORY_SCOPE;
(function (TERRITORY_SCOPE) {
    TERRITORY_SCOPE["MOBILE_USER"] = "MOBILE_USER";
    TERRITORY_SCOPE["TEAM"] = "TEAM";
})(TERRITORY_SCOPE || (exports.TERRITORY_SCOPE = TERRITORY_SCOPE = {}));
var CLIENT_REGIONS;
(function (CLIENT_REGIONS) {
    CLIENT_REGIONS["ANGLO_AFRICA"] = "ANGLO_AFRICA";
    CLIENT_REGIONS["FRANCO_AFRICA"] = "FRANCO_AFRICA";
    CLIENT_REGIONS["ASIA"] = "ASIA";
    CLIENT_REGIONS["EUROPE"] = "EUROPE";
    CLIENT_REGIONS["LATIN_AMERICA"] = "LATIN_AMERICA";
})(CLIENT_REGIONS || (exports.CLIENT_REGIONS = CLIENT_REGIONS = {}));
var CLIENT_SECTORS;
(function (CLIENT_SECTORS) {
    CLIENT_SECTORS["FOOD_BEVERAGE"] = "FOOD_BEVERAGE";
    CLIENT_SECTORS["EQUIPMENT_GOODS"] = "EQUIPMENT_GOODS";
    CLIENT_SECTORS["AGRICULTURAL_PRODUCTS"] = "AGRICULTURAL_PRODUCTS";
    CLIENT_SECTORS["HEALTH_AND_BEAUTY"] = "HEALTH_AND_BEAUTY";
    CLIENT_SECTORS["TELECOM"] = "TELECOM";
    CLIENT_SECTORS["FINANCIAL_SERVICES"] = "FINANCIAL_SERVICES";
    CLIENT_SECTORS["INDUSTRY"] = "INDUSTRY";
    CLIENT_SECTORS["OTHERS"] = "OTHERS";
})(CLIENT_SECTORS || (exports.CLIENT_SECTORS = CLIENT_SECTORS = {}));
exports.CAPACITY_QUOTA_FOR_TRIAL = 1e4;
exports.CAPACITY_QUOTA_FOR_LIVE = 1e6;
exports.CAPACITY_QUOTA_FOR_ENTERPRISE = 1e9;
exports.MOBILE_LOCK_SCREEN_TIMEOUT = {
    ALWAYS: "ALWAYS",
    AFTER_30_MINUTES: "AFTER_30_MINUTES",
    AFTER_60_MINUTES: "AFTER_60_MINUTES",
    NEVER: "NEVER",
};
var CLIENT_CATEGORY;
(function (CLIENT_CATEGORY) {
    CLIENT_CATEGORY["MARKET_RESEARCH"] = "MARKET_RESEARCH";
    CLIENT_CATEGORY["SAAS"] = "SAAS";
    CLIENT_CATEGORY["SAAS_PROJECT"] = "SAAS_PROJECT";
    CLIENT_CATEGORY["INTERNAL"] = "INTERNAL";
    CLIENT_CATEGORY["PARTNER"] = "PARTNER";
})(CLIENT_CATEGORY || (exports.CLIENT_CATEGORY = CLIENT_CATEGORY = {}));
var INVOICED_BY;
(function (INVOICED_BY) {
    INVOICED_BY["OPTIMETRIKS"] = "OPTIMETRIKS";
    INVOICED_BY["OM_SERVICES_KENYA"] = "OM_SERVICES_KENYA";
})(INVOICED_BY || (exports.INVOICED_BY = INVOICED_BY = {}));
var MOBILE_LOGIN_MODE;
(function (MOBILE_LOGIN_MODE) {
    MOBILE_LOGIN_MODE["GOOGLE_SSO"] = "GOOGLE_SSO";
    MOBILE_LOGIN_MODE["PHONE_OTP"] = "PHONE_OTP";
})(MOBILE_LOGIN_MODE || (exports.MOBILE_LOGIN_MODE = MOBILE_LOGIN_MODE = {}));
var WEB_LOGIN_MODE;
(function (WEB_LOGIN_MODE) {
    WEB_LOGIN_MODE["GOOGLE_SSO"] = "GOOGLE_SSO";
    WEB_LOGIN_MODE["EMAIL_PASSWORD"] = "EMAIL_PASSWORD";
})(WEB_LOGIN_MODE || (exports.WEB_LOGIN_MODE = WEB_LOGIN_MODE = {}));
var LANGUAGE;
(function (LANGUAGE) {
    LANGUAGE["en"] = "en";
    LANGUAGE["fr"] = "fr";
    LANGUAGE["es"] = "es";
})(LANGUAGE || (exports.LANGUAGE = LANGUAGE = {}));
var DEFAULT_DATE_FILTER;
(function (DEFAULT_DATE_FILTER) {
    DEFAULT_DATE_FILTER["TODAY"] = "TODAY";
    DEFAULT_DATE_FILTER["YESTERDAY"] = "YESTERDAY";
    DEFAULT_DATE_FILTER["LAST_7_DAYS"] = "LAST_7_DAYS";
    DEFAULT_DATE_FILTER["LAST_30_DAYS"] = "LAST_30_DAYS";
    DEFAULT_DATE_FILTER["THIS_WEEK"] = "THIS_WEEK";
    DEFAULT_DATE_FILTER["LAST_WEEK"] = "LAST_WEEK";
    DEFAULT_DATE_FILTER["THIS_MONTH"] = "THIS_MONTH";
    DEFAULT_DATE_FILTER["LAST_MONTH"] = "LAST_MONTH";
})(DEFAULT_DATE_FILTER || (exports.DEFAULT_DATE_FILTER = DEFAULT_DATE_FILTER = {}));
var NUMBER_FILTER;
(function (NUMBER_FILTER) {
    NUMBER_FILTER["GREATER_THAN"] = "GREATER_THAN";
    NUMBER_FILTER["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
    NUMBER_FILTER["LESS_THAN"] = "LESS_THAN";
    NUMBER_FILTER["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
    NUMBER_FILTER["IS"] = "IS";
    NUMBER_FILTER["IS_NOT"] = "IS_NOT";
})(NUMBER_FILTER || (exports.NUMBER_FILTER = NUMBER_FILTER = {}));
var ACTION_INCLUDE_TYPE;
(function (ACTION_INCLUDE_TYPE) {
    ACTION_INCLUDE_TYPE["INCLUDE_ALL_OBJECTS"] = "INCLUDE_ALL_OBJECTS";
    ACTION_INCLUDE_TYPE["INCLUDE_ALL_OBJECTS_EXCEPT"] = "INCLUDE_ALL_OBJECTS_EXCEPT";
    ACTION_INCLUDE_TYPE["EXCLUDE_ALL_OBJECTS_EXCEPT"] = "EXCLUDE_ALL_OBJECTS_EXCEPT";
})(ACTION_INCLUDE_TYPE || (exports.ACTION_INCLUDE_TYPE = ACTION_INCLUDE_TYPE = {}));
/* ----- WORKSPACE TEMPLATES ------ */
var WORKSPACE_TYPE;
(function (WORKSPACE_TYPE) {
    WORKSPACE_TYPE["TEMPLATE"] = "TEMPLATE";
    WORKSPACE_TYPE["CUSTOM"] = "CUSTOM";
})(WORKSPACE_TYPE || (exports.WORKSPACE_TYPE = WORKSPACE_TYPE = {}));
/**
 * List of standardized environments for different business use cases.
 * Each one will have a special set of Workflows, Activities, Lists, Dashboards, etc.
 */
var DEFAULT_CLIENT_TEMPLATES;
(function (DEFAULT_CLIENT_TEMPLATES) {
    DEFAULT_CLIENT_TEMPLATES["NEW_TPLT_RETAIL"] = "new_tplt_retail";
    DEFAULT_CLIENT_TEMPLATES["FINANCIAL_SERVICES"] = "financial_services";
    DEFAULT_CLIENT_TEMPLATES["AGRICULTURE"] = "agriculture";
    DEFAULT_CLIENT_TEMPLATES["FIELD_SERVICE_MANAGEMENT"] = "field_service_management";
})(DEFAULT_CLIENT_TEMPLATES || (exports.DEFAULT_CLIENT_TEMPLATES = DEFAULT_CLIENT_TEMPLATES = {}));
var WORKSPACE_SEGMENT;
(function (WORKSPACE_SEGMENT) {
    WORKSPACE_SEGMENT["FIELDPRO_SALES"] = "fieldpro_sales";
    WORKSPACE_SEGMENT["FIELDPRO_AGENT_NETWORK"] = "fieldpro_agent_network";
    WORKSPACE_SEGMENT["FIELDPRO_AGRI_SOURCING"] = "fieldpro_agri_sourcing";
    WORKSPACE_SEGMENT["FIELDPRO_SERVICE"] = "fieldpro_service";
})(WORKSPACE_SEGMENT || (exports.WORKSPACE_SEGMENT = WORKSPACE_SEGMENT = {}));
var THOUSAND_SEPARATOR;
(function (THOUSAND_SEPARATOR) {
    THOUSAND_SEPARATOR["COMMA"] = ",";
    THOUSAND_SEPARATOR["SPACE"] = " ";
})(THOUSAND_SEPARATOR || (exports.THOUSAND_SEPARATOR = THOUSAND_SEPARATOR = {}));
// prettier-ignore
exports.WORKSPACE_TEMPLATE_TO_SEGMENT = {
    [DEFAULT_CLIENT_TEMPLATES.NEW_TPLT_RETAIL]: WORKSPACE_SEGMENT.FIELDPRO_SALES,
    [DEFAULT_CLIENT_TEMPLATES.FINANCIAL_SERVICES]: WORKSPACE_SEGMENT.FIELDPRO_AGENT_NETWORK,
    [DEFAULT_CLIENT_TEMPLATES.AGRICULTURE]: WORKSPACE_SEGMENT.FIELDPRO_AGRI_SOURCING,
    [DEFAULT_CLIENT_TEMPLATES.FIELD_SERVICE_MANAGEMENT]: WORKSPACE_SEGMENT.FIELDPRO_SERVICE,
};
/**
 * Returns the lowercased client.workspace_type or undefined
 */
const getNormalizedWorkspaceType = (client) => {
    if (!client.workspace_type) {
        return undefined;
    }
    return client.workspace_type.toLowerCase();
};
exports.getNormalizedWorkspaceType = getNormalizedWorkspaceType;
/**
 * Returns the re-labelled version of the client.workspace_type (e.g for Crisp segments)
 */
const getNormalizedWorkspaceSegment = (client) => {
    const workspaceType = (0, exports.getNormalizedWorkspaceType)(client);
    if (!workspaceType) {
        return undefined;
    }
    return exports.WORKSPACE_TEMPLATE_TO_SEGMENT[workspaceType];
};
exports.getNormalizedWorkspaceSegment = getNormalizedWorkspaceSegment;
/**
 * @deprecated Remove it in 2 months
 */
var PG_BQ_TIMEZONE_MAPPING;
(function (PG_BQ_TIMEZONE_MAPPING) {
    PG_BQ_TIMEZONE_MAPPING["NZDT"] = "Etc/GMT-13";
    PG_BQ_TIMEZONE_MAPPING["IDLE"] = "Etc/GMT-12";
    PG_BQ_TIMEZONE_MAPPING["NZST"] = "Etc/GMT-12";
    PG_BQ_TIMEZONE_MAPPING["NZT"] = "Etc/GMT-12";
    PG_BQ_TIMEZONE_MAPPING["AESST"] = "Asia/Srednekolymsk";
    PG_BQ_TIMEZONE_MAPPING["ACSST"] = "Australia/LHI";
    PG_BQ_TIMEZONE_MAPPING["CADT"] = "Australia/LHI";
    PG_BQ_TIMEZONE_MAPPING["SADT"] = "Australia/LHI";
    PG_BQ_TIMEZONE_MAPPING["AEST"] = "Australia/Lindeman";
    PG_BQ_TIMEZONE_MAPPING["EAST"] = "Australia/Lindeman";
    PG_BQ_TIMEZONE_MAPPING["GST"] = "Australia/Lindeman";
    PG_BQ_TIMEZONE_MAPPING["LIGT"] = "Australia/Lindeman";
    PG_BQ_TIMEZONE_MAPPING["SAST"] = "Australia/Adelaide";
    PG_BQ_TIMEZONE_MAPPING["CAST"] = "Australia/Adelaide";
    PG_BQ_TIMEZONE_MAPPING["AWSST"] = "Asia/Chita";
    PG_BQ_TIMEZONE_MAPPING["JST"] = "Asia/Chita";
    PG_BQ_TIMEZONE_MAPPING["KST"] = "Asia/Chita";
    PG_BQ_TIMEZONE_MAPPING["MHT"] = "Asia/Chita";
    PG_BQ_TIMEZONE_MAPPING["WDT"] = "Asia/Chita";
    PG_BQ_TIMEZONE_MAPPING["MT"] = "Etc/GMT-8.30";
    PG_BQ_TIMEZONE_MAPPING["AWST"] = "Asia/Shanghai";
    PG_BQ_TIMEZONE_MAPPING["CCT"] = "Asia/Shanghai";
    PG_BQ_TIMEZONE_MAPPING["WADT"] = "Asia/Shanghai";
    PG_BQ_TIMEZONE_MAPPING["WST"] = "Asia/Shanghai";
    PG_BQ_TIMEZONE_MAPPING["JT"] = "Etc/GMT-7.30";
    PG_BQ_TIMEZONE_MAPPING["ALMST"] = "Asia/Bangkok";
    PG_BQ_TIMEZONE_MAPPING["WAST"] = "Asia/Bangkok";
    PG_BQ_TIMEZONE_MAPPING["CXT"] = "Asia/Bangkok";
    PG_BQ_TIMEZONE_MAPPING["ALMT"] = "Indian/Chagos";
    PG_BQ_TIMEZONE_MAPPING["MAWT"] = "Indian/Chagos";
    PG_BQ_TIMEZONE_MAPPING["IOT"] = "Asia/Oral";
    PG_BQ_TIMEZONE_MAPPING["MVT"] = "Asia/Oral";
    PG_BQ_TIMEZONE_MAPPING["TFT"] = "Asia/Oral";
    PG_BQ_TIMEZONE_MAPPING["AFT"] = "Asia/Kabul";
    PG_BQ_TIMEZONE_MAPPING["MUT"] = "Etc/GMT-4";
    PG_BQ_TIMEZONE_MAPPING["RET"] = "Etc/GMT-4";
    PG_BQ_TIMEZONE_MAPPING["SCT"] = "Etc/GMT-4";
    PG_BQ_TIMEZONE_MAPPING["IT"] = "Asia/Tehran";
    PG_BQ_TIMEZONE_MAPPING["EAT"] = "Europe/Istanbul";
    PG_BQ_TIMEZONE_MAPPING["BT"] = "Europe/Istanbul";
    PG_BQ_TIMEZONE_MAPPING["EETDST"] = "Europe/Istanbul";
    PG_BQ_TIMEZONE_MAPPING["HMT"] = "Europe/Istanbul";
    PG_BQ_TIMEZONE_MAPPING["BDST"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["CEST"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["CETDST"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["EET"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["FWT"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["IST"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["MEST"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["METDST"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["SST"] = "Europe/Bucharest";
    PG_BQ_TIMEZONE_MAPPING["BST"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["CET"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["DNT"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["FST"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["MET"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["MEWT"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["MEZ"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["NOR"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["SET"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["SWT"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["WETDST"] = "Europe/Berlin";
    PG_BQ_TIMEZONE_MAPPING["GMT"] = "Europe/London";
    PG_BQ_TIMEZONE_MAPPING["UT"] = "Europe/London";
    PG_BQ_TIMEZONE_MAPPING["UTC"] = "Europe/London";
    PG_BQ_TIMEZONE_MAPPING["Z"] = "Europe/London";
    PG_BQ_TIMEZONE_MAPPING["ZULU"] = "Europe/London";
    PG_BQ_TIMEZONE_MAPPING["WET"] = "Europe/London";
    PG_BQ_TIMEZONE_MAPPING["WAT"] = "America/Scoresbysund";
    PG_BQ_TIMEZONE_MAPPING["NDT"] = "Etc/GMT+2.30";
    PG_BQ_TIMEZONE_MAPPING["ADT"] = "America/Araguaina";
    PG_BQ_TIMEZONE_MAPPING["AWT"] = "America/Araguaina";
    PG_BQ_TIMEZONE_MAPPING["NFT"] = "Canada/Newfoundland";
    PG_BQ_TIMEZONE_MAPPING["NST"] = "Canada/Newfoundland";
    PG_BQ_TIMEZONE_MAPPING["AST"] = "America/Asuncion";
    PG_BQ_TIMEZONE_MAPPING["ACST"] = "America/Asuncion";
    PG_BQ_TIMEZONE_MAPPING["ACT"] = "Brazil/Acre";
    PG_BQ_TIMEZONE_MAPPING["EDT"] = "America/Asuncion";
    PG_BQ_TIMEZONE_MAPPING["CDT"] = "Brazil/Acre";
    PG_BQ_TIMEZONE_MAPPING["EST"] = "Brazil/Acre";
    PG_BQ_TIMEZONE_MAPPING["CST"] = "America/Guatemala";
    PG_BQ_TIMEZONE_MAPPING["MDT"] = "America/Guatemala";
    PG_BQ_TIMEZONE_MAPPING["MST"] = "US/Arizona";
    PG_BQ_TIMEZONE_MAPPING["PDT"] = "US/Arizona";
    PG_BQ_TIMEZONE_MAPPING["AKDT"] = "America/Tijuana";
    PG_BQ_TIMEZONE_MAPPING["PST"] = "America/Tijuana";
    PG_BQ_TIMEZONE_MAPPING["YDT"] = "America/Tijuana";
    PG_BQ_TIMEZONE_MAPPING["AKST"] = "America/Anchorage";
    PG_BQ_TIMEZONE_MAPPING["HDT"] = "America/Anchorage";
    PG_BQ_TIMEZONE_MAPPING["YST"] = "America/Anchorage";
    PG_BQ_TIMEZONE_MAPPING["AHST"] = "US/Aleutian";
    PG_BQ_TIMEZONE_MAPPING["HST"] = "US/Aleutian";
    PG_BQ_TIMEZONE_MAPPING["CAT"] = "US/Aleutian";
    PG_BQ_TIMEZONE_MAPPING["NT"] = "Pacific/Pago_Pago";
    PG_BQ_TIMEZONE_MAPPING["IDLW"] = "Etc/GMT+12";
})(PG_BQ_TIMEZONE_MAPPING || (exports.PG_BQ_TIMEZONE_MAPPING = PG_BQ_TIMEZONE_MAPPING = {}));
/*
  LIFE CYCLE utils
*/
var LIFE_CYCLE_TASK;
(function (LIFE_CYCLE_TASK) {
    LIFE_CYCLE_TASK["UPDATE_STOCK"] = "UPDATE_STOCK";
})(LIFE_CYCLE_TASK || (exports.LIFE_CYCLE_TASK = LIFE_CYCLE_TASK = {}));
exports.DEFAULT_LIFE_CYCLE = {
    statuses: [
        {
            id: "STOCK_MOVEMENT_APPROVED",
            label: "Stock approved",
            color: "#9E9E9E",
            entity: "stock_movement",
        },
    ],
    transitions: [],
    creation_status_rules: [
        {
            entity: "stock_movement",
            default_status_id: "STOCK_MOVEMENT_APPROVED",
            mobile_user_roles: undefined,
            web_user_roles: undefined,
            tasks: [LIFE_CYCLE_TASK.UPDATE_STOCK],
        },
    ],
};
